var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Head'),_c('iframe',{staticStyle:{"display":"block"},attrs:{"width":"100%","height":"700","src":"http://www.51weixiao.net/weschool/LoginInPage.html","frameborder":"0"}}),_c('Foot'),_c('FootBot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }